import {EntityContact} from "./EntityContact";
export const CreateEntityContact = `
    mutation createEntitycontact ($input: CreateEntitycontactInput!) {
        createEntitycontact (input: $input) {
            ${EntityContact}
        }
    }
`
;
